<template>
  <div>
    <div :class="(loading ? 'show-loader' : 'hide-loader')">
      <div class="el-loading-spinner">
        <svg viewBox="25 25 50 50" class="circular">
          <circle cx="50" cy="50" r="20" fill="none" class="path"></circle>
        </svg><!---->
      </div>
    </div>
    <div class="row order-view">
      <div class=" col-lg-11 col-md-12 pad-to-15">
        <div class="row">
          <div class="col-md-12">
            <div class="card">
              <div class="card-content">
                <div class="row ">
                  <div class="col-sm-12">

                    <h6 class=""><i class="ti-panel"></i> {{$t('orders.updateStatus')}}</h6>
                    <hr style="clear:both;">
                  </div>
                </div>
                <div class="row pad-bt-15">
                  <div class="col-md-12">
                    <div class="pull-left status-line pad-to-10">
                      <template v-for="(sts, i) in orderStatuses">
                          <span v-if="order.status.id === sts.type" :class="'current text-' + orderStatusClass(sts.type)" >{{$t('ordersStatus.' + sts.type)}}</span>
                          <span v-else-if="sts.isBefore" :class="'text-' + orderStatusClass(sts.type)">{{$t('ordersStatus.' + sts.type)}}</span>
                    <!--       <a v-else :class="'btn btn-sm btn-' + orderStatusClass(sts.type) + ' ' + disabledCls(sts.isBefore)" @click.prevent="updateStatus(sts.type, $t('ordersStatus.' + sts.type), sts.isBefore)" :disabled="sts.isBefore">{{$t('ordersStatus.' + sts.type)}}</a> -->
                      </template>
                    </div>
                    <div class="pull-right">
                      <select class="form-control" @change.prevent="changeStatus" v-model="currentOrdersStatus">
                        <option v-for="(sts, i) in orderStatuses"
                                :disabled="!sts.isAllowed"
                                :value="sts.type">
                              {{$t('ordersStatus.' + sts.type)}}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
                <div class="row pad-to-15">
                  <div class="col-sm-12">
                    <h6 class="pull-left">{{$t('orders.single')}} <span style="text-transform:none;">#{{order.token}}</span></h6>
                    <h6 class="pull-right"><i class="ti-shopping-cart"></i> {{$t('orders.ordDetails')}}</h6>
                    <hr style="clear:both;">
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6">
                    <div class="row pad-bt-10" v-if="showLocations">
                      <div class="col-lg-5 col-sm-6 col-xs-12 details-label">{{$t('orders.ordLocation')}}</div>
                      <div class="col-lg-7 col-sm-5 col-xs-12"><b>{{order.production_details ? order.production_details.location.name : '-'}}</b></div>
                    </div>

                    <div class="row pad-bt-10">
                      <div class="col-lg-5 col-sm-6 col-xs-12 details-label">{{$t('orders.date')}}</div>
                      <div class="col-lg-7 col-sm-5 col-xs-12"><b>{{formatDate(order.created_at)}}</b></div>
                    </div>
                    <div class="row pad-bt-10" v-if="order.delivery_type == 'MEET_HALF'">
                      <div class="col-lg-5 col-sm-6 col-xs-12 details-label">{{$t('orders.meetupLocation')}}</div>
                      <div class="col-lg-7 col-sm-5 col-xs-12"><b>{{order.delivery_details ? order.delivery_details.location.name : ''}}</b></div>
                    </div>
                    <div class="row pad-bt-10">
                      <div class="col-lg-5 col-sm-6 col-xs-12 details-label">{{$t('orders.madeAt')}}</div>
                      <div class="col-lg-7 col-sm-5 col-xs-12"><b>{{formatTime(order.created_at)}}</b></div>
                    </div>
                    <div class="row pad-bt-10" v-if="order.delivery_type !== 'EAT_LOCATION'">
                      <div class="col-lg-5 col-sm-6 col-xs-12 details-label pad-to-10">{{$t('orders.pickupTime')}}</div>
                      <div class="col-lg-7 col-sm-5 col-xs-12">
                        <!-- <b>{{formatTime(order.pickup_datetime)}}</b> -->
                        <el-time-picker
                          v-model="order.formatted_pickup_datetime"
                          class="in-inline-120"
                          arrow-control
                          :value-format="timeFormat" :format="timeFormat"
                          placeholder="Select time">
                        </el-time-picker>
                        <button class="btn btn-success btn-fill" @click.prevent="updateHour">{{$t('general.save')}}</button>
                      </div>
                    </div>
                    <div class="row pad-bt-10" v-else>
                      <div class="col-lg-5 col-sm-6 col-xs-12 details-label">{{$t('orders.reservationTime')}}</div>
                      <div class="col-lg-7 col-sm-5 col-xs-12">
                        <b>{{order.formatted_pickup_datetime}}</b>
                      </div>
                    </div>
                    <div class="row pad-bt-10" >
                      <div class="col-lg-5 col-sm-6 col-xs-12 details-label ">{{$t('orders.rating')}}</div>
                      <div class="col-lg-7 col-sm-5 col-xs-12">
                        <template v-for="i in 5">
                          <i class="fa fa-star text-purple" v-if="i <= order.star_feedback"></i>
                          <i class="fa fa-star-o" v-else></i>
                        </template>
                      </div>
                    </div>

                  </div>
                  <div class="col-md-6">
                    <div class="row pad-bt-10">
                      <div class="col-lg-5 col-sm-6 col-xs-12 details-label">{{$t('orders.type')}}</div>
                      <div class="col-lg-7 col-sm-5 col-xs-12"><b>{{$t('ordersTypes.' + order.order_type)}}</b></div>
                    </div>
                    <div class="row pad-bt-10">
                      <div class="col-lg-5 col-sm-6 col-xs-12 details-label">{{$t('orders.payment')}}</div>
                      <div class="col-lg-7 col-sm-5 col-xs-12">
                        <b>{{$t('paymentTypes.' + order.payment_type)}}</b>
                        <b v-if="order.payment_type === 'CARD'" v-html="getPaymetnStatus(order.capture_transaction_status)"></b>
                      </div>
                    </div>
                    <div class="row pad-bt-10">
                      <div class="col-lg-5 col-sm-6 col-xs-12 details-label">{{$t('orders.delivery')}}</div>
                      <div class="col-lg-7 col-sm-5 col-xs-12"><b>{{$t('deliveryTypes.' + order.delivery_type)}}</b></div>
                    </div>
                    <div class="row pad-bt-10" v-if="order.delivery_type === 'EAT_LOCATION'">
                      <div class="col-lg-5 col-sm-6 col-xs-12 details-label">{{$t('orders.reservationSeats')}}</div>
                      <div class="col-lg-7 col-sm-5 col-xs-12"><b>{{order.delivery_details ? order.delivery_details.how_many : '-'}}</b></div>
                    </div>

                    <div class="row pad-bt-10">
                      <div class="col-lg-5 col-sm-6 col-xs-12 details-label">{{$t('orders.custComments')}}</div>
                      <div class="col-lg-7 col-sm-5 col-xs-12"><span v-html="order.comments || '<small>'+$t('orders.none')+'</small>'"></span></div>

                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div> <!--  end col-md-12  -->

          <div class="col-md-4">
            <div class="card" style="min-height: 160px;">
              <div class="card-content">
                <div class="row">
                  <div class="col-xs-12">
                    <h6 class="mar-to-0"> <img class="icon-card-header" src="/static/img/icons/user-sm.png">  {{$t('orders.custDetails')}}</h6>
                    <hr class="sm">
                  </div>
                </div>
                <div class="row pad-bt-10">
                  <div class="col-lg-4 col-sm-5 col-xs-12 details-label"><b>{{$t('customers.name')}}</b></div>
                  <div class="col-lg-8 col-sm-7 col-xs-12" v-if="order.delivery_details_firstname"><b>{{order.delivery_details_firstname }} </b></div>
                  <div class="col-lg-8 col-sm-7 col-xs-12" v-else=""><b>{{order.customer ? order.customer.firstname : ''}} {{order.customer ? order.customer.lastname : ''}}</b></div>
                </div>
                <div class="row pad-bt-10">
                  <div class="col-lg-4 col-sm-5 col-xs-12 details-label"><b>{{$t('customers.email')}}</b></div>
                  <div class="col-lg-8 col-sm-7 col-xs-12">{{order.customer ? order.customer.email : ''}}</div>
                </div>
                <div class="row pad-bt-10">
                  <div class="col-lg-4 col-sm-5 col-xs-12 details-label"><b>{{$t('customers.phone')}}</b></div>
                  <div v-if="order.delivery_details_phone" class="col-lg-8 col-sm-7 col-xs-12">{{order.delivery_details_phone}}</div>
                  <div v-else class="col-lg-8 col-sm-7 col-xs-12">{{(order.customer && order.customer.phone) ? order.customer.phone : '-'}}</div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-4" v-for="address, type in order.address" >
            <div class="card address-box" style="min-height: 160px;">
              <div class="card-content">
                <h6>{{$t('orders.' + type)}}</h6>
                <hr class="sm">
                <div class="address-content">
                  <template v-if="address">
                  {{address.address_name}} {{address.street}} {{address.apartment}}<br/>
                  {{address.city}},
                  {{address.state}}<br/>
                  {{address.country}}
                  </template>
                  <template v-else>
                  -
                  </template>
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-12">
            <div class="card">
              <div class="">

                <table class="table orders-table">
                  <thead>
                      <tr>
                        <th>{{$t('orders.name')}}</th>
                        <th>{{$t('orders.qty')}}</th>
                        <th>{{$t('orders.unit')}}</th>
                        <th>{{$t('orders.total')}}</th>
                      </tr>
                  </thead>
                  <tbody>
                    <template v-for="customer in order.parts">
                      <tr v-if="order.order_type=='GROUP'" class="active"><td colspan="4">{{$t('customers.single')}}: {{customer.customer_name}}</td></tr>
                      <tr v-for="prod in customer.items">
                        <td>
                          {{prod.name}}
                          <!-- <ul v-if="prod.options">
                            <li v-for="opt in prod.options"> -->
                              <div v-for="opt in prod.options">+ {{opt.name}}<span v-if="opt.price>0"> ({{ formatMoneyAmount(opt.price, currency) }})</span></div>
                          <!--   </li>
                          </ul> -->
                          <div v-if="prod.additional_info != ''" class="pad-to-10"><span >{{$t('orders.custComments')}}: <i class="text-danger">{{prod.additional_info}}</i></span></div>
                        </td>
                        <td>{{prod.quantity}}</td>
                        <td>{{formatMoneyAmount(prod.price, currency)}}</td>
                        <td><b>{{formatMoneyAmount(parseFloat(prod.quantity) * parseFloat(prod.price_total_product), currency)}}</b></td>  
                      </tr>
                    </template>
                  </tbody>
                </table>
                <div class="clearfix"> </div>
                <div class="col-md-5 order-comment">
                  <!-- <h6><img class="pad-rg-5" src="/static/img/icons/comment.png">  {{$t('orders.custComments')}}</h6>
                  <hr class="sm">
                  {{order.comments ? order.comments : $t('orders.none')}} -->
                </div>
                <div class="col-md-7">
                  <table class="table no-border totals-table">
                    <tbody>
                      <template v-for="label of totals">
                        <tr :class="getRowClass(label)" v-if="label == 'totals_grandtotal' || order[label] > 0">
                          <td>{{$t('orders.' + label)}}</td>
                          <td class="text-right">{{formatMoneyAmount(order[label], currency, true)}}</td>
                        </tr>
                      </template>
                    </tbody>
                  </table>
                </div>
                <div class="clearfix"> </div>
              </div>
            </div>
          </div>
          <div class="clearfix"> </div>
          <div class="col-md-12">
            <div class="card">
              <div class="card-content">
                <h6><img class="pad-rg-5" src="/static/img/icons/comment.png">  {{$t('orders.adminComments')}}</h6>
                <!-- <hr class="sm"> -->
                <div class="form-group">
                  <textarea class="form-control" :placeholder="$t('orders.none')" rows="5" v-model="order.backoffice_comments"></textarea>
                </div>
                <div class="form-group">
                  <button class="btn btn-success btn-fill btn-sm" @click.prevent="saveComment">{{$t('general.save')}}</button>
                </div>
              </div>
            </div>

          </div> <!-- end col-md-6  -->

        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import Vue from 'vue'
  import {Select, Option, TimePicker, DatePicker, TimeSelect} from 'element-ui'
  import DataTables from 'vue-data-tables'
  import moment from 'moment'
  import countriesList from './../Customers/countries'
  import swal from 'sweetalert2'
  import 'sweetalert2/dist/sweetalert2.css'
  Vue.use(Select)
  Vue.use(DataTables)
  Vue.use(TimePicker)
  Vue.use(DatePicker)
  Vue.use(TimeSelect)
  export default {
    components: {
      [Select.name]: Select,
      [Option.name]: Option,
      [TimePicker.name]: TimePicker,
      [DatePicker.name]: DatePicker,
      [TimeSelect.name]: TimeSelect
    },
    props: {
      showLocations: {
        type: Boolean,
        required: true
      },
      callback: {
        required: true
      }
    },
    data () {
      return {
        order: [],
        countries: countriesList,
        modelValidations: {
          required: {
            required: true
          }
        },
        orderStatuses: [],
        currentOrdersStatus: 'NEW',
        currecy: '',
        timeFormat: this.getTimeFormat(),
        loading: true,
        totals: [
          'totals_subtotals',
          'totals_shipping',
          'totals_tip',
          'totals_discount',
          'totals_discount_loyalty_points',
          'totals_grandtotal'
        ]
      }
    },
    created: function () {
      this.getData()
    },
    methods: {
      getRowClass (label) {
        switch (label) {
          case 'totals_discount_loyalty_points':
          case 'totals_discount':
            return 'text-danger'
          case 'totals_grandtotal': return 'text-bold total-row'
          default: return ''
        }
      },
      isNew () {
        if (this.$route.params.id) {
          return false
        } else {
          return true
        }
      },
      disabledCls (isBefore) {
        if (isBefore) {
          return 'disabled'
        } else {
          return ''
        }
      },
      getPaymetnStatus (status) {
        switch (status) {
          // case null:
          //   return this.$t('paymentStatus.notPaid')
          case 'OK':
            return ' - <span class="text-success">' + this.$t('paymentStatus.paid') + '</span>'
          case 'NOT OK':
            return ' - <span class="text-danger">' + this.$t('paymentStatus.notOk') + '</span>'
          default:
            return ' - <span class="text-warning">' + this.$t('paymentStatus.notPaid') + '</span>'
        }
      },
      getData () {
        this.$nextTick(function () {
          this.loading = true
        })
        var data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany')
        }
        var self = this
        // get product data
        if (self.$route.params.id) {
          var id = self.$route.params.id

          self.apiRequest('/order/' + id, 'GET', data, function (response) {
            if (response.status === true) {
              response.data[0].formatted_pickup_datetime = self.formatTime(response.data[0].pickup_datetime)
              self.order = response.data[0]
              for (var iParts in self.order.parts) {
                for (var iItem in self.order.parts[iParts].items) {
                  let item = self.order.parts[iParts].items[iItem]
                  let sumOptions = 0
                  if (item.options && item.options.length) {
                    sumOptions = item.options.map(item => item.price).reduce((prev, next) => prev + next)
                  }
                  self.order.parts[iParts].items[iItem].price_total_product = (parseFloat(item.price) + parseFloat(sumOptions)).toFixed(2)
                }
              }
              let statusesRaw = self.$session.get('defaultData')['order_statuses']
              var isBefore = true
              var isAllowed = true
              self.orderStatuses = []
              self.currentOrdersStatus = self.order.status.id
              for (var ordType in statusesRaw) {
                // console.warn(ordType)
                for (var type in statusesRaw[ordType]) {
                  if (ordType === self.order.delivery_type && type !== 'DRAFT') {
                    if (type === 'CANCELED' && self.order.payment_type === 'CARD' && self.order.capture_transaction_status === 'OK') {
                      isAllowed = false
                    } else if (self.order.delivery_type === 'EAT_LOCATION') {
                      isAllowed = true
                    } else {
                      isAllowed = self.orderStatusAllowed(self.order.status.id, type)
                    }
                    self.orderStatuses.push({
                      'type': type,
                      'text': statusesRaw[ordType][type],
                      'isBefore': isBefore,
                      'isAllowed': isAllowed
                    })
                    if (self.order.status.id === type) {
                      isBefore = false
                    }
                  }
                }
              }

              self.currency = response.data[0]['currency']

              self.$nextTick(function () {
                self.loading = false
              })
            }
          })
        }
      },
      heartbeat (orderData) {
        // console.warn(' ------ heart beat on single order ---------')
        var self = this
        self.order.status = orderData.status

        let statusesRaw = self.$session.get('defaultData')['order_statuses']
        var isBefore = true
        var isAllowed = true

        self.orderStatuses = []
        self.currentOrdersStatus = self.order.status.id

        for (var ordType in statusesRaw) {
          for (var type in statusesRaw[ordType]) {
            if (ordType === self.order.delivery_type && type !== 'DRAFT') {
              isAllowed = self.orderStatusAllowed(self.order.status.id, type)
              self.orderStatuses.push({
                'type': type,
                'text': statusesRaw[ordType][type],
                'isBefore': isBefore,
                'isAllowed': isAllowed
              })
              if (self.order.status.id === type) {
                isBefore = false
              }
            }
          }
        }
        this.$nextTick(() => {
          // trigger next tick
        })
      },
      updateHour () {
        var id = this.$route.params.id
        var self = this
        if (this.order.formatted_pickup_datetime === '' || this.order.formatted_pickup_datetime === null) {
          swal({'text': self.$t('orders.orderHourError'), 'type': 'error', 'showConfirmButton': false, 'timer': 2000}).catch({})
        } else {
          var newTime = moment(String(this.order.pickup_datetime)).format('YYYY-MM-DD')
          newTime = moment(String(newTime + ' ' + this.order.formatted_pickup_datetime)).format('YYYY-MM-DD HH:mm:ss')
          var data = {
            id: id,
            token: this.$session.get('token'),
            company_id: this.$session.get('selectedCompany'),
            pickup_datetime: newTime
          }
          // console.warn(data)
          this.apiRequest('/order/' + id, 'PUT', data, function (response) {
            // console.warn(response)
            if (response.status === true) {
              swal(
                '',
                self.$t('orders.orderHourSuccess'),
                'success'
              )
            } else {
              swal(
                '',
                this.$t('validations.wentWrong'),
                'error'
              )
            }
          })
        }
      },
      saveComment () {
        var id = this.$route.params.id
        var data = {
          id: id,
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany'),
          backoffice_comments: this.order.backoffice_comments
        }
        var self = this
        this.apiRequest('/order/' + id, 'PUT', data, function (response) {
          // console.warn(response)
          if (response.status === true) {
            swal(
              '',
              self.$t('orders.orderCommnetSuccess'),
              'success'
            )
          } else {
            swal(
              '',
              this.$t('validations.wentWrong'),
              'error'
            )
          }
        })
      },
      updateStatus (status, label, disabled, revertOnCancel = false) {
        if (disabled) {
          return false
        }
        var self = this
        swal({
          text: self.$t('validations.areYouSure') + label,
          type: 'question',
          showCancelButton: true
        })
        .then((result) => {
          if (result) {
            var id = this.$route.params.id
            var data = {
              id: id,
              token: this.$session.get('token'),
              company_id: this.$session.get('selectedCompany'),
              status: status
            }
            this.apiRequest('/order/' + id, 'PUT', data, function (response) {
              // console.warn(response)
              if (response.status === true) {
                // set value for refreshOrdersCount - used in SideBar.vue
                self.$session.set('refreshOrdersCount', 'refresh')
                swal(
                  '',
                  self.$t('orders.orderStatusSuccess'),
                  'success'
                )
                self.getData()
                self.callback(id, {'id': status, 'type': label})
              } else {
                swal(
                  '',
                  self.$t('validations.wentWrong'),
                  'error'
                )
                if (revertOnCancel) {
                  self.currentOrdersStatus = self.order.status.id
                }
              }
            })
          }
        }).catch(() => {
          if (revertOnCancel) {
            self.currentOrdersStatus = self.order.status.id
          }
        })
      },
      changeStatus () {
        var status = this.currentOrdersStatus
        var label = this.$t('ordersStatus.' + this.currentOrdersStatus)
        this.updateStatus(status, label, false, true)
      }
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Orders/OrderView.vue